export const IOTMAX_CURRENT_STOCK_KEY = 'iotmax_current_stock'

export function normalizeIotmaxStock(stock) {
    if (!stock) return null
    return {
        stock_code: stock.stock_code === undefined || stock.stock_code === null ? '' : stock.stock_code,
        stock_name: stock.stock_name || stock.name || ''
    }
}

export function getStoredIotmaxStock() {
    const raw = localStorage.getItem(IOTMAX_CURRENT_STOCK_KEY)
    if (!raw) return null
    try {
        return normalizeIotmaxStock(JSON.parse(raw))
    } catch (error) {
        return null
    }
}

export function setStoredIotmaxStock(stock) {
    const normalized = normalizeIotmaxStock(stock)
    if (!normalized) {
        localStorage.removeItem(IOTMAX_CURRENT_STOCK_KEY)
        return
    }
    localStorage.setItem(IOTMAX_CURRENT_STOCK_KEY, JSON.stringify(normalized))
}

export function resolveCurrentIotmaxStock(stockList) {
    if (!Array.isArray(stockList) || stockList.length === 0) return null

    const loginStock = stockList.find(item => Number(item.is_login) === 1)
    if (loginStock) {
        return normalizeIotmaxStock(loginStock)
    }

    const storedStock = getStoredIotmaxStock()
    if (storedStock && storedStock.stock_code !== '') {
        const matched = stockList.find(item => String(item.stock_code) === String(storedStock.stock_code))
        if (matched) {
            return normalizeIotmaxStock(matched)
        }
    }

    return normalizeIotmaxStock(stockList[0])
}

export function formatIotmaxTimestamp(timestamp, options = {}) {
    if (!timestamp) return '-'

    const date = new Date(Number(timestamp) * 1000)
    if (Number.isNaN(date.getTime())) return '-'

    const pad = value => String(value).padStart(2, '0')
    const dateText = `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`

    if (options.dateOnly) return dateText

    return `${dateText} ${pad(date.getHours())}:${pad(date.getMinutes())}`
}

export function getIotmaxRoleList(userInfo) {
    const roleType = userInfo && userInfo.stock_user_role ? userInfo.stock_user_role.role_type || '' : ''
    return roleType.split(',').map(role => role.trim()).filter(Boolean)
}

export function hasIotmaxStockRole(userInfo, role, isSuperRoot = false) {
    if (isSuperRoot) return true
    return getIotmaxRoleList(userInfo).includes(role)
}

export function getIotmaxComputerCode(untilApi) {
    const guid = untilApi && untilApi.getCookie ? untilApi.getCookie('guid') || '' : ''
    return guid.substring(0, 6)
}

export async function getIotmaxFormAuth(toolApi, untilApi) {
    const computer_code = getIotmaxComputerCode(untilApi)
    const saltRes = await toolApi.ToolForm_saltGet({ computer_code })

    if (saltRes.errcode !== 0 || !saltRes.other) {
        throw new Error('获取salt失败')
    }

    return {
        computer_code,
        salt: saltRes.other
    }
}

export function parseIotmaxAddressInfo(addressInfo) {
    if (!addressInfo) return null

    if (addressInfo.includes('{')) {
        try {
            const info = JSON.parse(addressInfo)
            return {
                name: info.name || info.receiver_name || '',
                phone: info.phone || info.tel || '',
                address: info.address || ''
            }
        } catch (error) {}
    }

    const separators = ['，', ',']
    for (const separator of separators) {
        const parts = addressInfo.split(separator)
        if (parts.length >= 3) {
            return {
                name: parts[0].trim(),
                phone: parts[1].trim(),
                address: parts.slice(2).join(separator).trim()
            }
        }
    }

    return { name: '', phone: '', address: addressInfo }
}

export function getIotmaxShipmentStep(item = {}) {
    if (!item.debug_sure_user_id) return 1
    if (!item.need_sure_user_id) return 2
    if (!item.quality_sure_user_id) return 3
    if (!item.shipment_sure_user_id) return 4
    return 5
}

export function getIotmaxShipmentStepText(item = {}) {
    const texts = {
        1: '待调试',
        2: '待需求确认',
        3: '待质量确认',
        4: '待发货确认',
        5: '已完成'
    }
    return texts[getIotmaxShipmentStep(item)] || ''
}

export function parseIotmaxImageList(images) {
    if (!images) return []
    if (Array.isArray(images)) return images.filter(Boolean)
    return String(images).split(',').map(item => item.trim()).filter(Boolean)
}
